export class AuditMetaData{
    public Internal:boolean;
    public Seq:number;
    constructor(values: Object = {}){
        Object.assign(this, values);     
    }
}